import * as UI from '@mantine/core'
import { ModularComponent } from './modular.ts'
import { CharacterCard } from './character-card.tsx'
import { useMemo } from 'react'

export const CharactersPreview = ModularComponent('CharactersPreview')
  .withLifecycle(({ view }) => {
    const text = useMemo(
      () => JSON.stringify(view.chapter?.content) ?? '',
      [view.chapter?.content]
    )
    const characters = view.characters.filter((character) =>
      text.includes(character.name)
    )
    return { characters }
  })
  .withRender(({ lifecycle }) => (
    <UI.ScrollArea h="calc(100vh - 6rem)" mx={-16} mt={-8}>
      <UI.Stack p={16}>
        {lifecycle.characters.map((character) => (
          <CharacterCard preview key={character.id} {...character} />
        ))}
      </UI.Stack>
    </UI.ScrollArea>
  ))
